export default function PopularServices() {
  const services = [
    {
      title: 'Interior Detail',
      badge: 'Deep Clean',
      image: 'https://public.readdy.ai/ai/img_res/9e65edaa73a9ed1628b8ae14de6ce246.jpg',
      features: [
        'Deep vacuum of seats, carpets, and floor mats',
        'Steam sanitizing of all interior surfaces',
        'Plastics/trim detailing (dash, console, door panels, cup holders)',
        'Leather seats cleaned and conditioned',
        'A/C vents cleaned',
        'Pet hair removal (if needed)'
      ]
    },
    {
      title: 'Exterior Detail',
      badge: 'Shine & Protect',
      image: 'https://readdy.ai/api/search-image?query=luxury%20car%20exterior%20hand%20wash%20detailing%20perfect%20glossy%20paint%20finish%20water%20droplets%20premium%20vehicle%20care%20professional%20automotive%20detailing%20shiny%20clean%20surface&width=800&height=600&seq=service-exterior-wash-001&orientation=landscape',
      features: [
        'Careful hand wash with premium products',
        'Wheel and tire detailing',
        'Tire shine application',
        'Premium protective finish on paint',
        'Shields from sun, rain, and everyday grime',
        'Bug and tar removal'
      ]
    },
    {
      title: 'Full Detail',
      badge: 'Most Popular',
      popular: true,
      image: 'https://readdy.ai/api/search-image?query=complete%20luxury%20vehicle%20transformation%20before%20after%20full%20detailing%20service%20pristine%20condition%20showroom%20quality%20professional%20automotive%20care%20perfect%20finish%20inside%20outside&width=800&height=600&seq=service-full-detail-001&orientation=landscape',
      features: [
        'Complete interior deep cleaning',
        'Complete exterior wash and protection',
        'Like-new transformation',
        'Ideal for special occasions or sales',
        'Maximum attention to every detail',
        'Best value for complete care'
      ]
    }
  ];

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-wider text-sm font-semibold mb-3">
            OUR SERVICES
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Popular Services
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Choose the service that fits your needs. Every detail is customized based on your vehicle's condition.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border-2 ${
                service.popular ? 'border-yellow-500' : 'border-gray-800'
              } hover:border-yellow-500/60 transition-all duration-300 hover:transform hover:scale-105 relative`}
            >
              {/* Popular Badge */}
              {service.popular && (
                <div className="absolute top-4 right-4 z-10 bg-yellow-500 text-black px-4 py-1.5 rounded-full text-xs font-bold uppercase">
                  {service.badge}
                </div>
              )}

              {/* Service Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
                {!service.popular && (
                  <div className="absolute top-4 left-4 bg-black/80 text-yellow-500 px-3 py-1.5 rounded-full text-xs font-bold uppercase border border-yellow-500/30">
                    {service.badge}
                  </div>
                )}
              </div>

              {/* Service Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-6">{service.title}</h3>
                
                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-gray-300">
                      <i className="ri-checkbox-circle-fill text-yellow-500 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-sm leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="sms:+17863272644"
                  className={`w-full ${
                    service.popular
                      ? 'bg-yellow-500 text-black hover:bg-yellow-400'
                      : 'bg-gray-800 text-yellow-500 hover:bg-gray-700 border border-yellow-500/30'
                  } px-6 py-3.5 rounded-full font-bold transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer`}
                >
                  <i className="ri-message-3-line"></i>
                  Text for Quote
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Service Note */}
        <div className="mt-12 text-center">
          <div className="inline-block bg-gray-900/80 border border-yellow-500/30 rounded-2xl p-6 max-w-2xl">
            <h4 className="text-yellow-500 font-bold text-lg mb-2">Custom Pricing</h4>
            <p className="text-gray-300 text-sm leading-relaxed">
              Every vehicle is different. We provide accurate quotes based on your vehicle's size, condition, and specific needs. Text us with your vehicle details for a personalized quote.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
